import { combineReducers } from "@reduxjs/toolkit";
import adminUpdate from "./adminUpdateCompany/dataSlice";
import DownloadCompany from "./downloadCompany/dataSlice";
import AllCompanies from "./loadCompanies/dataSlice";
import CompanyById from "./loadCompanyById/dataSlice";

const reducer = combineReducers({
  allCompanies: AllCompanies,
  companyById: CompanyById,
  download: DownloadCompany,
  adminUpdate,
});

export default reducer;
